// Tiny logger that is a no-op in production builds.
// Keeps debug output during development without leaking to production.

const isDev = process.env.NODE_ENV !== "production";

const logger = {
    warn: (...args) => {
        if (isDev) console.warn(...args);
    },
    error: (...args) => {
        if (isDev) console.error(...args);
    },
    info: (...args) => {
        if (isDev) console.info(...args);
    },
};

export default logger;
